import React from 'react';
import edouard from '../assets/squad/edouard2.jpg';
import guillaume from '../assets/squad/guillaume-seiza.jpg';
import nicolas from '../assets/squad/nico-seiza.jpg';
import louis from '../assets/squad/louis.jpg';
import Teamate from './shared/Teamate';
// import Title from './shared/Title';

const Squad = () => {
  return (
    <section id="karate" className="relative py-20 bg-gradient-to-br from-white via-gray-50 to-white overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-primary/5 to-red-100/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-red-50/30 to-primary/5 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.196-2.121M17 20v-2a3 3 0 00-3-3H4a3 3 0 00-3 3v2h16zM4 10a3 3 0 106 0 3 3 0 00-6 0z"></path>
            </svg>
            L'équipe
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-primary">instructeurs</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Une équipe d'instructeurs passionnés et qualifiés, tous diplômés F.F.K.D.A, 
            pour vous accompagner dans votre progression en karaté et self-défense.
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          <Teamate
            img={edouard}
            name="Edouard Gonnet"
            title="Instructeur fédéral"
            grade=""
            desc="Quatrième dan F.F.K.D.A. Professeur de la section karaté et self défense."
          />
          <Teamate
            img={guillaume}
            name="Guillaume Chabrier"
            title="Instructeur fédéral"
            grade=""
            desc="Deuxième dan F.F.K.D.A. Professeur de la section adulte du club."
          />
          <Teamate
            img={louis}
            name="Louis Braun"
            title="Instructeur fédéral"
            grade=""
            desc="Deuxième dan F.F.K.D.A. Professeur de la section adulte du club."
          />
          <Teamate
            img={nicolas}
            name="Nicolas Birnbaum"
            title="Instructeur fédéral"
            grade=""
            desc="Deuxième dan F.F.K.D.A. Professeur de la section adulte et enfant du club."
          />
        </div>
        
        {/* Section valeurs de l'équipe - 4 carrés sur mobile */}
        <div className="mt-12 sm:mt-16 lg:mt-20 bg-white rounded-2xl sm:rounded-3xl shadow-xl p-6 sm:p-8 border border-gray-100">
          <div className="text-center mb-6 sm:mb-8 lg:mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4">Nos valeurs</h3>
            <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
              Ce qui nous unit et guide notre enseignement au quotidien
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Respect</h4>
              <p className="text-gray-600 text-xs sm:text-sm lg:text-base">
                Le respect mutuel guide nos relations.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h4 className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Excellence</h4>
              <p className="text-gray-600 text-xs sm:text-sm lg:text-base">
                Donner le meilleur dans chaque cours.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Bienveillance</h4>
              <p className="text-gray-600 text-xs sm:text-sm lg:text-base">
                Un cadre sécurisé pour progresser.
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4">
                <svg className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Persévérance</h4>
              <p className="text-gray-600 text-xs sm:text-sm lg:text-base">
                La régularité mène au succès.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Squad;
